import { initBrokerageListing } from './brokerage.js';

initBrokerageListing({ name: 'search' });
